import { Component, OnInit } from '@angular/core';
import { translate } from "@ngneat/transloco";


@Component({
  selector: 'app-help-center-dialog',
  templateUrl: './help-center-dialog.component.html',
  styleUrls: ['./help-center-dialog.component.scss']
})
export class HelpCenterDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
